import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import DownLoadBG from '../../../assets/app/home/home_download_bg.png'
import MobileImage from '../../../assets/app/home/home_download_mobile.png'
import AppGallery from '../../../assets/download/download_appgallery.png'
import GooglePlay from '../../../assets/download/download_googleplay.png'
import AppStore from '../../../assets/download/download_appstore.png'
import React from 'react'
import { GOOGLE_PLAY_STORE_LINK, APP_STORE_LINK, APP_GALLERY_LINK } from '../../../common/config'
import { useTranslation } from 'react-i18next'

export const SMAppHomeDownload: React.FC = () => {
    const { t } = useTranslation()
    
    // ======================= GooglePlay
    const clickGooglePlay = () => {
        window.open(GOOGLE_PLAY_STORE_LINK)
    }

    // ======================= AppStore
    const clickAppStore = () => {
        window.open(APP_STORE_LINK)
    }

    // ======================= AppGallery
    const clickAppGallery = () => {
        window.open(APP_GALLERY_LINK)
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            paddingTop: '120px',
        }}>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundImage: `url(${DownLoadBG})`,
                }}
            >
                {/* Moto */}
                <Image src={MobileImage} alt='' preview={false}></Image>
                {/* DownLoad */}
                <Box sx={{
                    flex: '1',
                    flexDirection: 'column',
                    alignContent: 'center',
                    display: 'flex',
                    justifyContent: 'center'
                }}>
                    {/* description */}
                    <Box sx={{
                        paddingLeft: '24px',
                        paddingRight: '24px'
                    }}>
                        <Typography fontWeight={700} fontSize={'24px'} color={'#141F39'}>
                            {t('t70')}
                        </Typography>

                        <Typography paddingTop={'10px'} fontWeight={400} fontSize={'14px'} color={'#141F39'}>
                            {t('t71')}
                        </Typography>
                        {/*app shop */}
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignContent: 'center',
                            paddingTop: '30px'
                        }}>
                            <Box
                                onClick={clickGooglePlay}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                }}>
                                <Image src={GooglePlay} width={150} height={50} alt='' preview={false}></Image>
                            </Box>

                            <Box
                                onClick={clickAppStore}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                }}>
                                <Image src={AppStore} width={150} height={50} alt='' preview={false}></Image>
                            </Box>

                            <Box
                                onClick={clickAppGallery}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    paddingTop: '5px',
                                    paddingBottom: '35px',
                                }}>
                                <Image src={AppGallery} width={150} height={50} alt='' preview={false}></Image>
                            </Box>
                        </Box>
                    </Box>



                </Box>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMAppHomeDownload
